import { Helmet } from 'react-helmet-async';
import HeroSection from "./components/HeroSection";
import PhilosophySection from "./components/PhilosophySection";
import ServicesSection from "./components/ServicesSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "nattō studio",
    "url": "https://natto.studio",
    "description": "Boutique consultancy offering marketing execution, operations support, and UK & Europe market entry.",
    "areaServed": ["GB", "Europe"],
    "serviceType": ["Marketing Execution", "Operations & Ways of Working", "UK & Europe Market Entry", "Trusted Specialist Network"]
  };

  return (
    <main className="pb-20 md:pb-[72px]">
      <Helmet>
        <title>nattō studio — Quietly effective consultancy partner</title>
        <meta name="description" content="Boutique consultancy offering marketing execution, operations support, and UK market entry. Built on trust, not theatre." />
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>
      <HeroSection />
      <PhilosophySection />
      <ServicesSection />
      <ContactSection />
    </main>
  );
}